/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import * as React from "react";
import {
  // AudioWaveform,
  // BookOpen,
  Bot,
  // Command,
  // Frame,
  GalleryVerticalEnd,
  // Map,
  // PieChart,
  Settings2,
  SquareTerminal,
  BarChart3,
  Shield,
} from "lucide-react";

import { NavMain } from "@/components/nav-main";
import { NavProjects } from "@/components/nav-projects";
import { TeamSwitcher } from "@/components/team-switcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { NavUser } from "./nav-user";

// This is sample data.
const data = {
  user: {
    name: "Abhinandan",
    avatar: "/avatars/shadcn.jpg",
  },
  teams: [
    {
      name: "Lenek Technologies",
      logo: GalleryVerticalEnd,
      plan: "Enterprise",
    },
    // {
    //   name: "Acme Corp.",
    //   logo: AudioWaveform,
    //   plan: "Startup",
    // },
    // {
    //   name: "Evil Corp.",
    //   logo: Command,
    //   plan: "Free",
    // },
  ],
  navMain: [
    {
      title: "Hospital",
      url: "#hospital",
      icon: SquareTerminal,
      isActive: true,
      // items: [
      //   {
      //     title: "History",
      //     url: "#",
      //   },
      //   {
      //     title: "Starred",
      //     url: "#",
      //   },
      //   {
      //     title: "Settings",
      //     url: "#",
      //   },
      // ],
    },
    {
      title: "Users",
      url: "#users",
      icon: Bot,
      // items: [
      //   {
      //     title: "Genesis",
      //     url: "#",
      //   },
      //   {
      //     title: "Explorer",
      //     url: "#",
      //   },
      //   {
      //     title: "Quantum",
      //     url: "#",
      //   },
      // ],
    },
    {
      title: "Analytics",
      url: "#analytics",
      icon: BarChart3,
      items: [
        {
          title: "Dashboard",
          url: "#analytics-dashboard",
        },
          {
            title: "Uploads",
            url: "#analytics-uploads",
          },
        // {
        //   title: "Studies",
        //   url: "#analytics-studies",
        // },
        // Future analytics features can be added here:
        // {
        //   title: "Usage Reports",
        //   url: "#analytics-usage",
        // },
        // {
        //   title: "Performance Metrics",
        //   url: "#analytics-performance",
        // },
        // {
        //   title: "User Activity",
        //   url: "#analytics-activity",
        // },
        // {
        //   title: "System Health",
        //   url: "#analytics-health",
        // },
      ],
    },
    {
      title: "API",
      url: "#api",
      icon: Settings2,
      items: [
        // {
        //   title: "General",
        //   url: "#",
        // },
        // {
        //   title: "Team",
        //   url: "#",
        // },
        // {
        //   title: "Billing",
        //   url: "#",
        // },
        // {
        //   title: "Limits",
        //   url: "#",
        // },
        {
          title: "API Details",
          url: "#api-details",
        },
        {
          title: "Token Ledger",
          url: "#api-ledger",
        },
      ],
    },
    {
      title: "AI Analysis",
      url: "/admin",
      icon: Shield,
      isAdmin: true,
    },
    // {
    //   title: "Template",
    //   url: "#",
    //   icon: Settings2,
    //   items: [
    //     {
    //       title: "General",
    //       url: "#",
    //     },
    //     {
    //       title: "Team",
    //       url: "#",
    //     },
    //     {
    //       title: "Billing",
    //       url: "#",
    //     },
    //     {
    //       title: "Limits",
    //       url: "#",
    //     },
    //   ],
    // },
    // {
    //   title: "Settings",
    //   url: "#",
    //   icon: Settings2,
    //   items: [
    //     {
    //       title: "General",
    //       url: "#",
    //     },
    //     {
    //       title: "Team",
    //       url: "#",
    //     },
    //     {
    //       title: "Billing",
    //       url: "#",
    //     },
    //     {
    //       title: "Limits",
    //       url: "#",
    //     },
    //   ],
    // },
  ],
  projects: [
    // {
    //   name: "Design Engineering",
    //   url: "#",
    //   icon: Frame,
    // },
    // {
    //   name: "Sales & Marketing",
    //   url: "#",
    //   icon: PieChart,
    // },
    // {
    //   name: "Travel",
    //   url: "#",
    //   icon: Map,
    // },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const {
    // state,
    open,
    // setOpen,
    // openMobile,
    // setOpenMobile,
    // isMobile,
    // toggleSidebar,
  } = useSidebar();

  const [user, setUser] = React.useState({
    name: "User",
    avatar: "/avatars/shadcn.jpg",
  });

  React.useEffect(() => {
    // Read username from localStorage
    const savedUsername = localStorage.getItem("username");
    if (savedUsername) {
      setUser((prevUser) => ({
        ...prevUser,
        name: savedUsername,
      }));
    }
  }, []);

  console.log(open);

  React.useEffect(() => {
    props.setOpen(open);
  }, [open]);
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain
          items={data.navMain}
          setActive={props.setActive}
          setAnalyticsTab={props.setAnalyticsTab}
          setApiTab={props.setApiTab}
        />
        {/* <NavProjects projects={data.projects} /> */}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
